import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const HomePickupCalculator = () => {
  const [distance, setDistance] = useState('');
  const [charge, setCharge] = useState(0);
  const [isFree, setIsFree] = useState(true);

  const calculateCharge = (km) => {
    const dist = parseFloat(km);
    if (isNaN(dist) || dist <= 0) {
      setCharge(0);
      setIsFree(true);
      return;
    }

    if (dist <= config.business.homePickup.freeRadius) {
      setCharge(0);
      setIsFree(true);
    } else {
      const extraKm = dist - config.business.homePickup.freeRadius;
      const calculatedCharge = extraKm * config.business.homePickup.chargePerKm;
      setCharge(calculatedCharge);
      setIsFree(false);
    }
  };

  const handleDistanceChange = (e) => {
    const value = e.target.value;
    setDistance(value);
    calculateCharge(value);
  };

  return (
    <section className="process" style={{ background: 'var(--white)', borderTop: '3px solid var(--black)' }}>
      <motion.p
        className="sec-label"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Home Pickup Calculator
      </motion.p>
      <motion.h2
        className="sec-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        style={{ color: 'var(--black)' }}
      >
        CHECK <span style={{ color: 'var(--gold)' }}>PICKUP CHARGES</span>
      </motion.h2>
      
      <motion.div
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          background: 'var(--cream)',
          padding: '40px',
          border: '3px solid var(--black)',
          borderRadius: '8px'
        }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div style={{ marginBottom: '24px' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '14px', 
            fontWeight: '700', 
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: '12px',
            color: 'var(--black)'
          }}>
            Enter Distance from Shop (in km)
          </label>
          <input
            type="number"
            value={distance}
            onChange={handleDistanceChange}
            placeholder="Enter distance in km"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '16px',
              border: '3px solid var(--black)',
              background: 'var(--white)',
              fontFamily: 'inherit'
            }}
          />
        </div>

        <div style={{
          padding: '24px',
          background: isFree ? 'var(--gold)' : 'var(--black)',
          color: isFree ? 'var(--black)' : 'var(--white)',
          textAlign: 'center',
          border: '3px solid var(--black)'
        }}>
          {distance && parseFloat(distance) > 0 ? (
            <>
              {isFree ? (
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>
                    ✅ FREE PICKUP
                  </div>
                  <div style={{ fontSize: '14px' }}>
                    Distance is within {config.business.homePickup.freeRadius}km radius
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>
                    ₹{charge.toFixed(0)}
                  </div>
                  <div style={{ fontSize: '14px' }}>
                    Pickup charge for {distance}km
                    <br />
                    (Free for first {config.business.homePickup.freeRadius}km, ₹{config.business.homePickup.chargePerKm}/km after)
                  </div>
                </div>
              )}
            </>
          ) : (
            <div style={{ fontSize: '16px', fontWeight: '500' }}>
              Enter distance to calculate charges
            </div>
          )}
        </div>

        <div style={{
          marginTop: '24px',
          padding: '16px',
          background: 'var(--light)',
          fontSize: '13px',
          color: 'var(--gray)',
          lineHeight: '1.6'
        }}>
          <strong>Note:</strong> Home pickup is free within {config.business.homePickup.freeRadius}km radius from our shop. 
          For distances beyond {config.business.homePickup.freeRadius}km, charges apply at ₹{config.business.homePickup.chargePerKm} per km.
        </div>
      </motion.div>
    </section>
  );
};

export default HomePickupCalculator;
